import { rootApi } from 'src/services/rootApi';

import { ImportEntity } from './import-fields';

type ApiTag = Parameters<typeof rootApi.util.invalidateTags>[0][number];

/**
 * The cached data an import changes, refetched once it finishes. A contact import can create
 * companies as well, and any import can add to a list.
 */
export const IMPORTED_RECORD_TAGS: Record<ImportEntity, ApiTag[]> = {
  contact: ['OrgContacts', 'Companies', 'EntityLists', 'ListItems'],
  company: ['Companies', 'EntityLists', 'ListItems'],
  candidate: ['OrgCandidates', 'EntityLists', 'ListItems'],
};
